module.exports = __webpack_public_path__ + "img/f72459a2626c4809a5753178369e6bb0.6f0460bc.jpg";